import { SmartImage } from "@/components/SmartImage";
import { formatPrice } from "@/data/menu";
import { motion, useReducedMotion } from "framer-motion";

const slug = (s) =>
  s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

// Editorial food row: larger photo + NAME · description · price. Tap for details.
export const ProductRow = ({ product, onOpen }) => {
  const price = formatPrice(product.price);
  const meta = product.weight || product.volume;
  const desc = product.ingredients || product.description;
  const reduce = useReducedMotion();
  return (
    <motion.button
      type="button"
      data-testid={`product-${slug(product.name)}`}
      onClick={() => onOpen(product)}
      initial={reduce ? false : { opacity: 0, y: 12 }}
      whileInView={reduce ? undefined : { opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
      className="group flex w-full items-start gap-4 py-5 text-left transition-colors duration-200 hover:bg-white/50 focus:outline-none focus-visible:bg-white/70 lg:gap-7 lg:py-7"
    >
      {product.image ? (
        <div className="h-[112px] w-[112px] shrink-0 overflow-hidden rounded-[4px] bg-roty-cream lg:h-[180px] lg:w-[180px]">
          <SmartImage
            base={product.image}
            alt={product.name}
            width={180}
            height={180}
            sizes="(max-width: 1023px) 112px, 180px"
            className={`h-full w-full transition-transform duration-300 ease-out group-hover:scale-[1.02] ${product.subcategory === "pizza" ? "object-contain" : "object-cover"}`}
          />
        </div>
      ) : null}

      <div className="min-w-0 flex-1">
        <div className="flex items-baseline justify-between gap-3">
          <h3 className="text-[17px] font-extrabold uppercase leading-tight tracking-tight text-roty-red lg:text-2xl">
            {product.name}
          </h3>
          {price ? (
            <span className="shrink-0 whitespace-nowrap text-[17px] font-extrabold tabular-nums text-roty-red lg:text-2xl">
              {price}
            </span>
          ) : null}
        </div>
        {desc ? (
          <p className="mt-1.5 max-w-prose text-sm leading-snug text-roty-ash lg:mt-2 lg:text-base lg:leading-relaxed">
            {desc}
          </p>
        ) : null}
        {product.flavors ? (
          <p className="mt-1 text-xs leading-snug text-roty-ash/90">{product.flavors}</p>
        ) : null}
        {meta ? (
          <span className="mt-1.5 inline-block text-xs font-semibold uppercase tracking-wide text-roty-ash/70 lg:mt-2">
            {meta}
          </span>
        ) : null}
      </div>
    </motion.button>
  );
};
